module.exports = __webpack_public_path__ + "img/1.e53ff7ab.jpg";